import { fromFetch } from 'rxjs/fetch';
import { z } from 'zod/v4';

import { requiredHeaders } from '../../../models/required-headers';
import { selectData } from '../../../utils/select-data';
import { withJwt } from '../../../utils/with-jwt';
import { fleetEnvironment } from '../fleet-environment';
import { fleetCustomPlaceSchema } from '../schemas/fleet-custom-place.schema';

/**
 * Get an array of custom places that belong to each given place set by id
 * @param setIds Array of place set ids
 * @returns An array of custom places that belong to each of the place sets
 */
export function getPlaceSetsCustomPlaces(this: unknown, setIds: number[]) {
  const params = new URLSearchParams();
  setIds.forEach((id) => {
    params.append('customPlaceSets', id.toString());
  });
  return withJwt((jwtAuthHeaders) =>
    fromFetch(
      new Request(
        `${fleetEnvironment.resolve(this).placeSetsCustomPlacesUrl}?${params.toString()}`,
        {
          method: 'GET',
          headers: {
            ...requiredHeaders,
            ...jwtAuthHeaders,
          },
        }
      )
    )
  ).pipe(selectData(z.array(fleetCustomPlaceSchema)));
}
